export default "__VITE_ASSET__DAD3FhbZ__"